import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 300px;
  align-items: center;
  padding: 20px 20px;
  min-height: 360px;
`;

const Title = styled.h3`
  color: #B6936C;
  font-weight: bold;
  text-align: center;
  overflow-wrap: break-word;
  text-transform: uppercase;
  width: 85%;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  margin: 10px 0;
`;

const P = styled.p`
  color: #707070;
  font-size: 14px;
  text-align: center;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 150px;
  min-width: 150px;
  max-width: 25vw;
  @media (max-width: 768px) {
    min-width: 200px;
  }
`;

export {
  Container,
  Title,
  P,
  ImageContainer,
};